import React from 'react';
import useTranslation from "../../i18n/useTranslation";
import {GlobalStyles} from "../../constants/styles";

export default function YouTubeCTA() {
    const {t} = useTranslation();
    return (
        <div className="card">
            <div
                className="card-header d-flex align-items-center"
                style={{backgroundColor: GlobalStyles.colors.canary, padding: "10px 20px"}}
            >
                <i className="fab fa-youtube mr-2" style={{color: GlobalStyles.colors.woodsmoke}}></i>
                <h3
                    className="card-title mb-0"
                    style={{color: GlobalStyles.colors.woodsmoke, fontFamily: "'Poppins', sans-serif"}}
                >
                    {t('defaultHome.youtube.title')}
                </h3>
            </div>

            <div className="card-body" style={{backgroundColor: "#1f1f2e"}}>
                <div className="row">
                    <div className="col-12 col-md-4 mb-3">
                        <div className="embed-responsive embed-responsive-16by9">
                            <iframe
                                className="embed-responsive-item"
                                src="https://www.youtube.com/embed/UYrz90yaIac"
                                allowFullScreen
                                title="AngeonX Sports Onboarding"
                            ></iframe>
                        </div>
                    </div>

                    <div className="col-12 col-md-8">
                        <p className="text-justify mb-3" style={{color: "#fff"}}>
                            {t('defaultHome.youtube.subtitle')}
                            <br/><br/>
                            🎯 <strong>{t('defaultHome.youtube.why')}</strong><br/>
                            {t('defaultHome.youtube.because')}
                        </p>

                        <a
                            href="https://www.youtube.com/@KBolaSport"
                            className="btn btn-danger"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <i className="fab fa-youtube mr-1"></i>
                            {t('defaultHome.youtube.visitButton')}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
